export const COMMON_FIELDS = [
  {
    custom_field_id: 1,
    field_format: 'date',
    identify: 'begin_at',
    is_required: true,
    name: '开始时间',
  },
  {
    custom_field_id: 2,
    field_format: 'date',
    identify: 'end_at',
    is_required: true,
    name: '结束时间',
  },
  {
    custom_field_id: 49,
    field_format: 'text',
    identify: 'demand_detail_default',
    submit_key: 'description',
    is_required: true,
    name: '需求详情',
    possible_values: '未免退单，请务必准确填写',
  },
];

export enum QuotationsType {
  YIKOUJIA = 'buyout_price',
  XIAOHAO = 'by_consume',
}

import {convertDemandDetailToProjectDetail as commonConvertDemandDetailToProjectDetail} from '@mpc/common/src/features/MPCDemand/utils';


// ##全局处理详情
export const convertDemandDetailToProjectDetail = (demandDetail: any) => {
  // 内包使用的公共处理
  commonConvertDemandDetailToProjectDetail(demandDetail);

  // 旧详情处理
  const { child_demands, demand_plan_info, demand_principals, demand_suppliers } = demandDetail;

  demandDetail.child_projects = child_demands;
  if (demandDetail.child_projects) {
    demandDetail.child_projects.forEach((cp: any) => {
      const { demand_plan_info: childPlanInfo } = cp;

      if (childPlanInfo) {
        childPlanInfo.project_id = childPlanInfo.demand_id;
      }

      cp.project_plan_info = childPlanInfo;
    });
  }

  demandDetail.project_plan_info = demand_plan_info;
  if (demandDetail.project_plan_info) {
    const { demand_id, demand_planners } = demandDetail.project_plan_info;

    demandDetail.project_plan_info.project_id = demand_id;
    demandDetail.project_plan_info.custom_values = [];

    COMMON_FIELDS.forEach((cf: any) => {
      const customValue = {
        custom_field: { ...cf },
        custom_field_id: cf.custom_field_id,
        id: cf.custom_field_id,
        value: demandDetail.project_plan_info[cf.submit_key || cf.identify],
      };

      demandDetail.project_plan_info.custom_values.push(customValue);
    });

    demandDetail.project_plan_info.project_planners = demand_planners;
  }

  demandDetail.project_principals = demand_principals;
  if (demandDetail.project_principals) {
    demandDetail.project_principals.forEach((pp: any) => {
      const { demand_id } = pp;

      pp.project_id = demand_id;
    });
  }

  demandDetail.project_suppliers = demand_suppliers;
  if (demandDetail.project_suppliers) {
    demandDetail.project_suppliers.forEach((ps: any) => {
      const { demand_id, demand_supplier_quotes } = ps;

      ps.project_id = demand_id;

      if (demand_supplier_quotes) {
        ps.project_supplier_quotes = demand_supplier_quotes;

        ps.project_supplier_quotes.forEach((psq: any) => {
          const { demand_supplier_id } = psq;

          psq.project_supplier_id = demand_supplier_id;

          if (psq.currency) {
            psq.currency = psq.currency.toLowerCase();
          }

          if (typeof psq.quote_price === 'number') {
            psq.quote_price = String(psq.quote_price);
          }

          if (typeof psq.requote_price === 'number') {
            psq.requote_price = String(psq.requote_price);
          }
        });

        // ps.demand_supplier_quotes = undefined;
      }
    });
  }

  if (demandDetail.budget_currency) {
    demandDetail.budget_currency = demandDetail.budget_currency.toLowerCase();
  }
  if (demandDetail.group_type) {
    demandDetail.group_type = demandDetail.group_type.toLowerCase();
  }
  if (demandDetail.oa_status) {
    demandDetail.oa_status = demandDetail.oa_status.toLowerCase();
  }
  if (demandDetail.priority) {
    demandDetail.priority = demandDetail.priority.toLowerCase();
  }
  if (demandDetail.state) {
    demandDetail.state = demandDetail.state.toLowerCase();
  }
  if (demandDetail.quote_currency) {
    demandDetail.quote_currency = demandDetail.quote_currency.toLowerCase();
  }
  if (demandDetail.settle_currency) {
    demandDetail.settle_currency = demandDetail.settle_currency.toLowerCase();
  }
  if (demandDetail.support_type) {
    demandDetail.support_type = demandDetail.support_type.toLowerCase();
  }
  if (demandDetail.root_demand_ext_data?.purchasing_method) {
    demandDetail.root_demand_ext_data.purchasing_method =
      demandDetail.root_demand_ext_data.purchasing_method.toLowerCase();
  }

  if (demandDetail.demand_advertising) {
    if (demandDetail.demand_advertising.translated_dspf_offer_currency) {
      demandDetail.demand_advertising.offer_currency_name =
        demandDetail.demand_advertising.translated_dspf_offer_currency;
    }
  }

  // 流程 版本
  demandDetail.$flow_vision = 'v0';
  if (demandDetail.flow_flag === 'OLD_ONLINE_PROCESS') {
    demandDetail.$flow_vision = 'v0';
  } else if (demandDetail.flow_flag === undefined) {
    demandDetail.$flow_vision = 'v0';
  } else {
    demandDetail.$flow_vision = 'v1';
  }
  // mock 测试数据
  if (localStorage.getItem('$flow_vision')) {
    demandDetail.$flow_vision = localStorage.getItem('$flow_vision');
  }

  // 如果是三级单，则合作通过通过报价信息进行过滤
  if (demandDetail?.depth === 2) {
    let demand_supplier_quotes = demandDetail?.demand_suppliers?.[0]?.demand_supplier_quotes;
    if (demand_supplier_quotes?.length > 0) {
      demandDetail.demand_suppliers[0].demand_supplier_quotes = demand_supplier_quotes.filter(
        (item: any) => item.winning,
      );
      demand_supplier_quotes = demandDetail.demand_suppliers[0].demand_supplier_quotes;
    }
    if (demand_supplier_quotes?.length > 0 && demandDetail.demand_plan_info?.cooperate_accounts?.length) {
      demandDetail.demand_plan_info.cooperate_accounts = demandDetail.demand_plan_info.cooperate_accounts
        .map((item: any, index: number) => {
          const it = demand_supplier_quotes?.find?.((v) => {
            return v.cooperate_account_id === item.id;
          });
          let $supplier_settle_price;
            if (demandDetail?.need_cooperate_account_supplier_settle_price) {
              // 合作内容中添加供应商填写的最终结算金额
              $supplier_settle_price = {
                value: it?.supplier_settle_price,
                currency: it?.currency,
              };
            }
          return ({
          ...item,
          $supplier_settle_price,
          $orderIndex: index,
          case_close_report_cooperate_account_attachments: it?.case_close_report_cooperate_account_attachments, // 结案报告 (差旅、餐补)
          contain_travel_expenses_reimbursement: it?.contain_travel_expenses_reimbursement, // 是否包含差旅费报销
          need_actual_execution: it?.need_actual_execution, // 是否实际执行
        })})
        .filter((item: any) => {
          return demand_supplier_quotes.some((quote: any) => quote.cooperate_account_id === item.id);
        });
    }
  }

  // 结构化版本大于等于1，则必为合并上传
  if (demandDetail.structured_version >= 1) {
    demandDetail.quote_upload_method = 'MULTI_UPLOAD';
  }

  // 二级单创建时间为2025年2月17日之后且必须上传作品为是
  demandDetail.$contentStructured = !!demandDetail?.content_marketing_case_structured_version 
    && demandDetail?.need_content_marketing_attach;

  // 判断 广告投放流程 按消耗结算逻辑
  // 新流程 通过 is_bind_execution_data 判断
  demandDetail.$isAdsXiaohao = (() => {
    switch (demandDetail.$flow_vision) {
      case 'v0':
        return demandDetail?.project_plan_info?.ad_settle_way === QuotationsType.XIAOHAO;
      case 'v1':
      default:
        return demandDetail.is_bind_execution_data === 1;
    }
  })();
  if (demandDetail.$isAdsXiaohao) {
    // 兼容旧流程，判断逻辑
    if (typeof demandDetail.project_plan_info === 'object') {
      demandDetail.project_plan_info.ad_settle_way = QuotationsType.XIAOHAO;
    }
  }

  /** 三级单 */
  demandDetail.$thirdLevelOrder = +demandDetail?.depth === 2;

  return demandDetail;
};

